import React from 'react'
import { Button } from 'antd'
import { CheckOutlined } from '@ant-design/icons'
import { useMarkAllNotificationsAsReadMutation } from '../../../store/apis/notification.api'

const NotificationsPopoverTitle = ({ hasUnreadNotifications }) => {
    const [markAllAsRead, { isLoading: isMarkingAllAsRead }] = useMarkAllNotificationsAsReadMutation()

    const handleMarkAllAsRead = () => {
        markAllAsRead()
    }

    return (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 16 }}>
            <span>Notifications</span>
            {hasUnreadNotifications && (
                <Button
                    type='link'
                    size='small'
                    icon={<CheckOutlined />}
                    onClick={handleMarkAllAsRead}
                    loading={isMarkingAllAsRead}
                >
                    Mark All as Read
                </Button>
            )}
        </div>
    )
}

export default NotificationsPopoverTitle

